import { render } from "./ThemesAutoSegment.vue?vue&type=template&id=4c479d64"
import script from "./ThemesAutoSegment.vue?vue&type=script&lang=js"
export * from "./ThemesAutoSegment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__